import { f as fetchHTML } from './index-Da0J-i1G.js';

class LoadMore extends HTMLElement {
  html;
  url = this.dataset.url;
  direction = this.dataset.direction;
  loadMoreButton = this.querySelector('button');
  productList = document.querySelector('[data-products-list]');
  loadMoreButtons = document.querySelectorAll('load-more button');
  paginationRanges = document.querySelectorAll('pagination-range');
  promoBlocks = document.querySelectorAll('[data-promo-block]');

  connectedCallback() {
    this.loadMoreButton.addEventListener('click', () => this.loadMore());
  }

  /**
   * loadMore
   */
  async loadMore() {
    this.html = await this.fetchMore();
    this.addProducts();
    this.updateLoadMoreURL();
    this.updateSearchParams();
    this.updatePaginationRange();
  }

  /**
   * fetchMore
   */
  async fetchMore() {
    try {
      this.toggleLoadMoreButtons(true);
      return await fetchHTML(this.url);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.toggleLoadMoreButtons(false);
    }
  }

  /**
   * addProducts
   */
  addProducts() {
    const fetchedProducts = this.html.querySelectorAll('[data-products-list] > li');

    if (!fetchedProducts) return;

    if (this.direction === 'previous') {
      this.productList.prepend(...fetchedProducts);
    } else if (this.direction === 'next') {
      this.productList.append(...fetchedProducts);
    }
  }

  /**
   * Update URL
   * @param {HTML} html The HTML of the page
   */
  updateLoadMoreURL() {
    const loadMoreElement = this.html.querySelector(
      `load-more[data-direction="${this.direction}"]`
    );

    // If there is no load more element, remove the component
    if (!loadMoreElement) return this.remove();

    // Replace the current element with the new one
    this.replaceWith(loadMoreElement);
  }

  /**
   * Toggle the load more button
   */
  toggleLoadMoreButtons(loading) {
    this.loadMoreButtons.forEach((button) => {
      button.classList.toggle('button--loading', loading);
    });
  }

  /**
   * Update the search params
   */
  updateSearchParams() {
    history.replaceState(null, '', this.url);
  }

  /**
   * Update the pagination range
   */
  updatePaginationRange() {
    const fetchedPaginationRange = this.html.querySelector('pagination-range');

    this.paginationRanges?.forEach((paginationRange) => {
      // Update the start number
      if (this.direction === 'previous') {
        const startNumber = fetchedPaginationRange.getAttribute('start-number');
        paginationRange.setAttribute('start-number', startNumber);
      }

      // Update the end number
      else if (this.direction === 'next') {
        const endNumber = fetchedPaginationRange.getAttribute('end-number');
        paginationRange.setAttribute('end-number', endNumber);
      }
    });
  }
}

customElements.define('load-more', LoadMore);
